import { helpers } from "@vuelidate/validators";

export const specialCharactersValidator = helpers.withMessage(
  "Special characters are not allowed",
  helpers.regex(
    /^[a-zA-Z0-9À-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿ @._-]*$/
  )
);
